/*
 * @fileTile: 
 * @Description: 
 * @Autor: zsf
 * @Date: 2022-09-03 11:47:17
 * @LastEditTime: 2024-04-16 14:40:52
 */
let secondCross = '' // 本地调试如有跨域问题则赋值，若上线则把cross置空，并改http.js里的域名 /secondApi
const coldchainAPI = {
    // 查询冷链运输单基本信息
    queryColdChainBaseInfo: {
        method: 'get',
        url: '/logistics/coldChain/driver/baseInfo'
    },
    // 查看运输过程信息（冷链）
    queryColdChainProcess: {
        method: 'get',
        url: '/logistics/coldChain/driver/process/query'
    },
    // 更新运输过程信息（冷链）
    updateColdChainProcess: {
        method: 'post',
        url: '/logistics/coldChain/driver/process/update'
    },
    // 获取货物信息
    getGoodsInfo: {
        method: 'get',
        url: '/logistics/coldChain/driver/process/goodsInfo/query',
        mask: true
    },
    // 更新货物信息
    updateGoodsInfo: {
        method: 'post',
        url: '/logistics/coldChain/driver/process/goodsInfo/update'
    },
    // 装运单
    mesDeliveryOrderList: {
        method: 'get',
        url: '/logistics/mesDeliveryOrder/list'
    },
    // 装运单货物列表
    queryGroupListByDeliveryNo: {
        method: 'get',
        url: '/logistics/mesDeliveryOrderGoods/queryGroupListByDeliveryNo'
    },
    // 装运单货物提交
    mesDeliveryOrderGoodsSubmit: {
        method: 'post',
        url: '/logistics/mesDeliveryOrderGoods/submit'
    },
    // 装运单货物异常上报
    mesDeliveryOrderGoodsAbnormalReport: {
        method: 'post',
        url: '/logistics/mesDeliveryOrderGoods/abnormalReport'
    },
    // 时效跟踪
    mesDeliveryOrderNodeList: {
        method: 'get',
        url: '/logistics/mesDeliveryOrderNode/queryListByDeliveryNo'
    },
    // 时效跟踪-更新状态
    mesDeliveryOrderSubmitNode: {
        method: 'post',
        url: '/logistics/mesDeliveryOrderNode/submitNode'
    },
    // 时效跟踪-异常上报
    mesDeliveryOrderAbnormalReport: {
        method: 'post',
        url: '/logistics/mesDeliveryOrder/abnormalReport'
    },
    // 签收单列表
    mesReceiptList: {
        method: 'get',
        url: '/logistics/mesReceipt/list'
    },
    // 签收单数量
    mesReceiptListTotal: {
        method: 'get',
        url: '/logistics/mesReceipt/total'
    },
    // 签收单地点更正
    mesReceiptEditAddress: {
        method: 'post',
        url: '/logistics/mesReceipt/editAddress'
    },
    // 签收单异常上报
    mesReceiptAbnormalReport: {
        method: 'post',
        url: '/logistics/mesReceipt/abnormalReport'
    },
    // 签收单详情
    getDetailByDeliveryAndSalesNo: {
        method: 'get',
        url: '/logistics/mesReceipt/getDetailByDeliveryAndSalesNo'
    },
    // 签收单更新状态
    mesReceiptEditState: {
        method: 'post',
        url: '/logistics/mesReceipt/editState'
    },

    // 销售订单列表
    mesSalesQueryListByDeliveryNo: {
        method: 'get',
        url: '/logistics/mesReceipt/queryListByDeliveryNo'
    },

    // 销售订单异常上报
    mesSalesOrderAbnormalReport: {
        method: 'post',
        url: '/logistics/mesReceipt/abnormalReport'
    },
    // 销售订单更新状态
    mesSalesOrderEditState: {
        method: 'post',
        url: '/logistics/mesReceipt/editState'
    },
    // -装运单列表(本地查询)
    mesDeliveryList: {
        method: 'get',
        url: '/logistics/mesTransportDelivery/driver/list'
    },
    // -装运单详情(本地查询)
    mesDeliveryDetailInfo: {
        method: 'get',
        url: '/logistics/mesTransportDelivery/driver/getDetailInfo'
    },
    // -确认装运单
    mesMileageandfeeCommit: {
        method: 'post',
        url: '/logistics/mesTransportDelivery/driver/mileageandfee/commit'
    },
    // -装运单暂存
    mesMileageandfeeTempStorage: {
        method: 'post',
        url: '/logistics/mesTransportDelivery/driver/mileageandfee/tempStorage'
    },
    // -确认接单
    mesMileageandReceiveOrder: {
        method: 'post',
        url: '/logistics/mesTransportDelivery/driver/receiveOrder'
    },
}

export default coldchainAPI



// WEBPACK FOOTER //
// ./src/api/coldchain.js